import { Card, CardBody, CardHeader, Flex, Text } from '@chakra-ui/react';
import { GetOfferMetadataFragment } from '@client/graphql/__generated__/types';
import { formatToCurrency } from '@common/utils/formatter';
import dayjs from 'dayjs';
import { isNil } from 'lodash';

export const OfferDrawerSidebar = ({
  offerDetails,
}: {
  offerDetails?: GetOfferMetadataFragment;
}) => {
  return (
    <Flex direction="column" gap={4} height="100%" pl={4} width="400px">
      <Card width="100%">
        <CardHeader>
          <Text color="whiteAlpha.700">Key Terms</Text>
        </CardHeader>
        <CardBody>
          <Flex direction="column" gap={1}>
            <Flex alignItems="center" justifyContent="space-between">
              <Text fontWeight="medium">Purchase Price</Text>
              <Text color="whiteAlpha.700">
                {formatToCurrency(offerDetails?.purchase_price)}
              </Text>
            </Flex>
            {!isNil(offerDetails?.due_diligence_fee) && (
              <Flex alignItems="center" justifyContent="space-between">
                <Text fontWeight="medium">Due Diligence Fee</Text>
                <Text color="whiteAlpha.700">
                  {formatToCurrency(offerDetails?.due_diligence_fee)}
                </Text>
              </Flex>
            )}
            <Flex alignItems="center" justifyContent="space-between">
              <Text fontWeight="medium">Earnest Money</Text>
              <Text color="whiteAlpha.700">
                {formatToCurrency(offerDetails?.earnest_money_deposit)}
              </Text>
            </Flex>
            <Flex alignItems="center" justifyContent="space-between">
              <Text fontWeight="medium">Seller Concessions</Text>
              <Text color="whiteAlpha.700">
                {formatToCurrency(offerDetails?.seller_concessions)}
              </Text>
            </Flex>
            {!isNil(offerDetails?.due_diligence_end_date) && (
              <Flex alignItems="center" justifyContent="space-between">
                <Text fontWeight="medium">Due Diligence Date</Text>
                <Text color="whiteAlpha.700">
                  {dayjs(offerDetails?.due_diligence_end_date).format(
                    'MM/DD/YYYY'
                  )}
                </Text>
              </Flex>
            )}
            <Flex alignItems="center" justifyContent="space-between">
              <Text fontWeight="medium">Close Date</Text>
              {!isNil(offerDetails?.close_date) && (
                <Text color="whiteAlpha.700">
                  {dayjs(offerDetails?.close_date).format('MM/DD/YYYY')}
                </Text>
              )}
            </Flex>
          </Flex>
        </CardBody>
      </Card>

      <Card width="100%">
        <CardHeader>
          <Text color="whiteAlpha.700">Buyer Info</Text>
        </CardHeader>
        <CardBody>
          <Flex direction="column" gap={1} minWidth="0">
            <Flex
              alignItems="center"
              justifyContent="space-between"
              overflow="hidden"
              textOverflow="ellipsis"
              whiteSpace="nowrap"
            >
              <Text fontWeight="medium">Buyer Name</Text>
              <Text color="whiteAlpha.700">{offerDetails?.buyer_name}</Text>
            </Flex>
            {!isNil(offerDetails?.co_buyer_name) && (
              <Flex
                alignItems="center"
                gap={2}
                justifyContent="space-between"
                minWidth="0"
                overflow="hidden"
                textOverflow="ellipsis"
                whiteSpace="nowrap"
              >
                <Text fontWeight="medium">Co Buyer Name</Text>
                <Text color="whiteAlpha.700">
                  {offerDetails?.co_buyer_name}
                </Text>
              </Flex>
            )}
            <Flex alignItems="center" justifyContent="space-between">
              <Text fontWeight="medium">Financing Type</Text>
              <Text color="whiteAlpha.700">{offerDetails?.financing_type}</Text>
            </Flex>
          </Flex>
        </CardBody>
      </Card>
    </Flex>
  );
};
